import { render, staticRenderFns } from "./ViewEmployeesDurations.vue?vue&type=template&id=dea15136&scoped=true&"
import script from "./ViewEmployeesDurations.vue?vue&type=script&lang=ts&"
export * from "./ViewEmployeesDurations.vue?vue&type=script&lang=ts&"
import style0 from "./ViewEmployeesDurations.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewEmployeesDurations.vue?vue&type=style&index=1&id=dea15136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea15136",
  null
  
)

component.options.__file = "ViewEmployeesDurations.vue"
export default component.exports